import(/* webpackMode: "eager" */ "/var/www/front/live/eduvalu-front/app/instructors/InstructorsPage.tsx")